import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NiceScrollService } from '../_services/nice-scroll.service';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css'],
    standalone: false
})

export class PrivacyPolicyComponent implements OnInit {
  constructor(private titleService: Title,
              private niceScroll: NiceScrollService
              ) {
                niceScroll.scrollToTop();
              }
  ngOnInit() {
    this.titleService.setTitle('Privacy Policy | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    // this.canonicalService.setCanonicalURL();
  }
}
